import React, {PropTypes} from 'react';

export class SimpleButton extends React.Component {
  static propTypes = {
    primary: PropTypes.bool,
    secondary: PropTypes.bool,
    style: PropTypes.object,
    onClick: PropTypes.func,
    label: PropTypes.string,
    children: PropTypes.element
  };

  static defaultProps = {
    style: {}
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  componentWillMount() {
    this.style = this.getStyle();
  }

  getStyle() {
    const {defaultTextColor, primaryTextColor, secondaryTextColor} = this.context.muiTheme.flatButton;

    return {
      root: {
        cursor:'pointer',
        border: 'none',
        background: 'transparent',
        color: defaultTextColor,
        lineHeight: 2.8,
        padding: 0,
        fontSize: 16,
        textTransform: 'none'
      },
      primary: {
         color: primaryTextColor
      },
      secondary: {
        color: secondaryTextColor
      }
    }
  }

  render() {
    const {onClick, style, primary, secondary, label} = this.props;
    let bStyle = Object.assign(
      {},
      this.style.root,
      style,
      primary ? this.style.primary : {},
      secondary ? this.style.secondary : {}
    );

    return (
      <button onClick={onClick}
              style={bStyle}>
        {label}
      </button>
    );
  }
}

export default SimpleButton;



// WEBPACK FOOTER //
// ./src/components/common/SimpleButton.js